// extracted by mini-css-extract-plugin
module.exports = {"errorImgContainer":"loadable-image-component_errorImgContainer__22M4r"};